import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=794a7774"
import script from "./DropZone.vue?vue&type=script&lang=js"
export * from "./DropZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports